export const NoTitle = ({ componentSize, name }) => {
  const style = {
    height: 2,
    width: componentSize.current[name].width - 100,
  };
  return <div style={style}></div>;
};
